<template>
  <div class="fixed flex flex-col top-0 left-0 w-screen h-screen pt-0 p-4 z-20 bg-white overflow-y-auto" :class="{ hidden: isHidden }">
    <header class="inset-x-0 top-0 min-h-16 flex flex-row items-center justify-end border-b border-grey-300">
      <img @click="hideModal()" src="@/assets/close.png" class="h-8 opacity-50" :class="{ hidden: disableClose }">
    </header>
    <div class="relative flex flex-col gap-2 items-center justify-center mt-8 mb-16 max-w-screen-sm h-full w-full mx-auto">
      <!-- IMAGE -->
      <!-- TODO: Remove handling the icon when not needed anymore -->
      <div v-if="/\p{Extended_Pictographic}/u.test(image)" class="text-9xl">{{ image }}</div>
      <img v-else-if="image" :src="require('@/assets/modal/' + image)" class="h-32 mb-8">

      <!-- TITLE -->
      <h2 v-if="title">{{ title }}</h2>

      <!-- CONTENT -->
      <slot></slot>

      <!-- BUTTON -->
      <button v-if="button" @click='buttonClick()'>{{ button }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalContainer',
  components: {
  },
  props: {
    modelValue: Boolean,
    image: String,
    title: String,
    button: String,
    disableClose: Boolean,
  },
  emits: [
    'update:modelValue',
    'button-click',
  ],
  data() {
    return {
    }
  },
  beforeMount() {
  },
  watch: {
  },
  methods: {
    hideModal() {
      this.isHidden = true
    },
    buttonClick() {
      this.$emit('button-click')
    },
  },
  computed: {
    isHidden: {
      get() {
        return !this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', !value)
      },
    }
  }
}
</script>